import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import '@domo/domo-icons/dist/domocons/domocons.css';
import './Icon.css';

const Icon = ({size, icon, shade, className, ...rest}) => (
  <i
    role="presentation"
    {...rest}
    className={cx('Icon', size, icon, shade, className)}
  />
);

Icon.SIZES = {
  PICO: 'Icon--pico',
  NANO: 'Icon--nano',
  MICRO: 'Icon--micro',
  MEDIUM: 'Icon--medium',
  THUMB: 'Icon--thumb',
  JUMBO: 'Icon--jumbo',
  SCALABLE: 'Icon--scalable',
};

Icon.OPTIONS = {
  AIRPLANE: 'icon-airplane',
  ANNOTATION: 'icon-annotation',
  APPROVAL_CENTER: 'icon-approval-center',
  ARROW_BOX: 'icon-arrow-box',
  ARROW_CURVED_LEFT: 'icon-arrow-curved-left',
  ARROW_LEFT: 'icon-arrow-left',
  ARROW_UP: 'icon-arrow-up',
  AVATAR: 'icon-avatar',
  BETA: 'icon-beta',
  BUILDING: 'icon-building',
  BUZZ: 'icon-buzz',
  CHART_BAR_VERTICAL: 'icon-chart-bar-vertical',
  CARD_FILE: 'icon-card-file',
  CARD_NOTEBOOK: 'icon-card-notebook',
  CARD_POLL: 'icon-card-poll',
  CELL_PHONE: 'icon-cell-phone',
  CERTIFIED: 'icon-certified',
  CHAIN_UNLINKED: 'icon-chain-unlinked',
  CHART_PIE: 'icon-chart-pie',
  CHAT_BUBBLES: 'icon-chat-bubbles',
  CHECK: 'icon-check',
  CHECK_CIRCLE: 'icon-check-circle',
  CHECKED_LIST: 'icon-checked-list',
  CHECK_SQUARE: 'icon-check-square',
  CHEVRON_DOWN: 'icon-chevron-down',
  CHEVRON_RIGHT: 'icon-chevron-right',
  COLLAPSE: 'icon-collapse',
  COMPUTER: 'icon-computer',
  CONNECTOR: 'icon-connector',
  DATATYPE_DATETIME: 'icon-datatype-datetime',
  DATATYPE_NUMBER: 'icon-datatype-number',
  DATATYPE_TEXT: 'icon-datatype-text',
  DOTS_HORIZONTAL: 'icon-dots-horizontal',
  ENVELOPE: 'icon-envelope',
  EXCEL: 'icon-excel',
  EXCLAMATION_TRIANGLE_OUTLINE: 'icon-exclamation-triangle-outline',
  EXPAND: 'icon-expand',
  EYE: 'icon-eye',
  FACEBOOK: 'icon-facebook',
  FUNNEL: 'icon-funnel',
  FUNNEL_BOX: 'icon-funnel-box',
  FUNNEL_PLUS: 'icon-funnel-plus',
  GLOBE: 'icon-globe',
  HOME: 'icon-home',
  INBOX_EMPTY: 'icon-inbox-empty',
  INFO_CIRCLE: 'icon-info-circle',
  LINES_HORIZONTAL: 'icon-lines-horizontal',
  LINKEDIN: 'icon-linkedin',
  LIST_BULLETED: 'icon-list-bulleted',
  LOCK_CLOSED: 'icon-lock-closed',
  LOCK_NO_KEYHOLE: 'icon-lock-no-keyhole',
  LOCK_OPEN: 'icon-lock-open',
  MAP_MARKER: 'icon-map-marker',
  PAGES_BARS: 'icon-pages-bars',
  PAPERCLIP: 'icon-paperclip',
  PENCIL: 'icon-pencil',
  PEOPLE: 'icon-people',
  PERSON: 'icon-person',
  PERSON_PLUS: 'icon-person-plus',
  PHONE: 'icon-phone',
  PIN: 'icon-pin',
  PLUS: 'icon-plus',
  PLUS_CIRCLE: 'icon-plus-circle',
  PLUS_BUBBLE: 'icon-plus-bubble',
  POWERPOINT: 'icon-powerpoint',
  QUOTE: 'icon-quote',
  SAVE: 'icon-save',
  SEARCH: 'icon-search',
  SELECT_CHART: 'icon-select-chart',
  SMILE_PLUS: 'icon-smile-plus',
  SMS: 'icon-sms',
  STAR: 'icon-star',
  STAR_MINUS: 'icon-star-minus',
  STAR_OUTLINE: 'icon-star-outline',
  SUMO: 'icon-sumo',
  TABLE: 'icon-table',
  THUMBS_UP: 'icon-thumbs-up',
  TRASH: 'icon-trash',
  TWITTER: 'icon-twitter',
  UNPIN: 'icon-unpin',
  VIDEO: 'icon-video',
  X: 'icon-x',
};

Icon.SHADES = {
  NONE: '',
  LIGHT: 'Icon--light-shade',
  MEDIUM: 'Icon--medium-shade',
};

Icon.propTypes = {
  icon: PropTypes.oneOf(Object.values(Icon.OPTIONS)).isRequired,
  size: PropTypes.oneOf(Object.values(Icon.SIZES)).isRequired,
  shade: PropTypes.oneOf(Object.values(Icon.SHADES)).isRequired,
};

Icon.defaultProps = {
  size: Icon.SIZES.MICRO,
  shade: Icon.SHADES.MEDIUM,
};

export default Icon;
